import { render, staticRenderFns } from "./ImportedPeoplePage.vue?vue&type=template&id=40cc0560&scoped=true&"
import script from "./ImportedPeoplePage.vue?vue&type=script&lang=js&"
export * from "./ImportedPeoplePage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=40cc0560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc0560",
  null
  
)

export default component.exports